export default "__VITE_ASSET__Dca29Sb___"